export default {
  SET_CONTACT_INFO(state, contactInfo) {
    state.contactInfo = contactInfo;
  },
};
